import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

interface BreadcrumbItem {
  name: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-xs text-foreground-400">
      <Link to="/" className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
        <i className="ri-home-4-line text-sm"></i>
      </Link>
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-1.5">
          <i className="ri-arrow-right-s-line text-foreground-300 text-xs"></i>
          {item.href ? (
            <Link to={item.href} className="hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap">
              {item.name}
            </Link>
          ) : (
            <span className="text-foreground-600">{item.name}</span>
          )}
        </span>
      ))}
    </nav>
  );
}